
import { Options, Vue } from 'vue-class-component';
import { CourseInfo, Team } from '@/models/CourseInfo';
import TeamList from './TeamList.vue';
import TeamEditor from './TeamEditor.vue';
import LoadingScreen from './LoadingScreen.vue';
import axios from 'axios';
import jwt_decode from 'jwt-decode';

@Options({
  components: { TeamList, TeamEditor, LoadingScreen }
})
export default class Main extends Vue {
  course: CourseInfo | null = null;
  selected: Team | null = null;
  canEdit = false;
  canBecomeOwner = false;
  isSyncing = false;

  public created(): void {
    const token = window.location.hash.substr(1);
    const jwt = jwt_decode<{ [claim: string]: string }>(token);
    const role = jwt["role"];
    this.canEdit = role == "Teacher" || role == "Manager";
    this.canBecomeOwner = role == "Manager";

    axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    axios.get('/CourseInfo').then(resp => this.course = resp.data);
  }

  deleteSelected(): void {
    this.course!.teams = this.course!.teams.filter(t => t != this.selected);
    this.selected = null;
  }

  editTeam(team: Team): void {
    this.selected = team;
  }

  sync(): void {
    this.isSyncing = true;
    axios.post('/CourseInfo/Sync')
        .then(s => this.isSyncing = false)
        .then(() => axios.get('/CourseInfo'))
        .then(resp => this.course = resp.data);
  }
}
